import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {DialogData} from '../auswertungen-formdialog-neu/auswertungen-formdialog-neu.component';
import {MatSort} from '@angular/material/sort';
import {select, Store} from '@ngrx/store';
import {AuswertungState} from '../../store/reducer/auswertungen.reducer';
import { Stimulsoft } from 'stimulsoft-reports-js/Scripts/stimulsoft.viewer';


@Component({
  selector: 'app-auswertungen-table',
  templateUrl: './auswertungen-table.component.html',
  styleUrls: ['./auswertungen-table.component.scss']
})

export class AuswertungenTableComponent implements OnInit, AfterViewInit {

  constructor( public store: Store<{ zeiterfassung: AuswertungState }> ) {

  }
  /* ENDE Beim Leeren des Datepickers wird an der leeren Stelle das Grid neu geladen */
//  viewer: any = new Stimulsoft.Viewer.StiViewer(null, 'StiViewer', false);

  /**
   * Sets parts of the time mask to datasource
   *
   * @param Zeit - Parts of the time table
   */

  ngOnInit(): void {
    // Loading Viewer view
    Stimulsoft.Base.StiLicense.Key = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHmpMFGIvKXt+0qL8oOfYCePmdl89Db00G622UYvHM74Kho8fxVfA5Hmk/iCgfRw7qeEsRlVjqwg8RcFeEAnQymDk5yd2/okky1fZy4MSoewgM6OUcbcojaqaY96fyQa5VlONSe6PWNNVBCmoaUL/YJZeg4AuxBQvIJFZmwtDvfOZ/ug9VdKB8h8mmoSQhvA1qANoYclQR1kaTNBAXKsrVcn8MKItIoVrJZY0/lINUiPZHfARTMWfdhA5t+UjQQOwWLTIxMha5bsoCfjFG7maIk/ES4kO2OKR5k6Huxg6PBg8lwtn+cw3kQ4pD46VgGTRXh7xCxAUD9hMf5F9rDFyctBRH1o7pdYbHFApsyLcRNoDnefn/LdRAAY+eDs3xTWs4fIslZs+w2EmySosds9X/z6sk6iTQoXrKXmHHnVMP0chZiZgAXLpvMYCquWuahBiCauNLIFdfw3sChkTwWJJln6CFdK+44o6HflqSNu7MmaJGT+qi6XWcAxKBbYkKq81+o=';
    Stimulsoft.StiOptions.WebServer.url = 'http://local.curion.ch/stimulsoftDesigner/reports/handler.php';
  }


  ngAfterViewInit(): void {
    // this.loadReport();
  }

  public loadReport(showBenutzername: boolean,
                    showZwischensummen: boolean,
                    showDetails: boolean,
                    showSeparat: boolean,
                    showAllUsers: boolean,
                    filterDatumStart: string,
                    filterDatumEnde: string,
                    zeitAuswahl: number
  ): void{
  //  Stimulsoft.Base.StiLicense.Key = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHmpMFGIvKXt+0qL8oOfYCePmdl89Db00G622UYvHM74Kho8fxVfA5Hmk/iCgfRw7qeEsRlVjqwg8RcFeEAnQymDk5yd2/okky1fZy4MSoewgM6OUcbcojaqaY96fyQa5VlONSe6PWNNVBCmoaUL/YJZeg4AuxBQvIJFZmwtDvfOZ/ug9VdKB8h8mmoSQhvA1qANoYclQR1kaTNBAXKsrVcn8MKItIoVrJZY0/lINUiPZHfARTMWfdhA5t+UjQQOwWLTIxMha5bsoCfjFG7maIk/ES4kO2OKR5k6Huxg6PBg8lwtn+cw3kQ4pD46VgGTRXh7xCxAUD9hMf5F9rDFyctBRH1o7pdYbHFApsyLcRNoDnefn/LdRAAY+eDs3xTWs4fIslZs+w2EmySosds9X/z6sk6iTQoXrKXmHHnVMP0chZiZgAXLpvMYCquWuahBiCauNLIFdfw3sChkTwWJJln6CFdK+44o6HflqSNu7MmaJGT+qi6XWcAxKBbYkKq81+o=';

    const options = new Stimulsoft.Viewer.StiViewerOptions();
    options.exports.showExportToCsv = false;
    options.exports.showExportToHtml = false;
    options.exports.showExportToHtml5 = false;
    options.exports.showExportToPowerPoint = false;
    options.exports.showExportToImageSvg = false;
    options.exports.showExportToOpenDocumentWriter = false;
    options.exports.showExportToText = false;
    options.exports.showExportToOpenDocumentCalc = false;
    options.exports.showExportToDocument = false;
    options.toolbar.showOpenButton = false;
    options.toolbar.printDestination = Stimulsoft.Viewer.StiPrintDestination.Pdf;
    const report = new Stimulsoft.Report.StiReport();
    const viewer = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
    // Load report from url

    // tslint:disable-next-line:max-line-length
    report.loadFile(window.location.protocol + '//' + window.location.hostname + '/myDay/backend/auswertungen/temp/zeitReport_' + sessionStorage.getItem('session').slice(10) + '.json');
  //  report.loadFile(window.location.protocol + '//' + window.location.hostname + '/myDay/backend/auswertungen/zeitReport.mrt');
    report.dictionary.variables.getByName('showName').valueObject = showBenutzername;
    report.dictionary.variables.getByName('showZwischensummen').valueObject = showZwischensummen;
    report.dictionary.variables.getByName('showDetails').valueObject = showDetails;
    report.dictionary.variables.getByName('showSeparat').valueObject = showSeparat;
    report.dictionary.variables.getByName('showAllUsers').valueObject = showAllUsers;
    report.dictionary.variables.getByName('filterDatumStart').valueObject = filterDatumStart;
    report.dictionary.variables.getByName('filterDatumEnde').valueObject = filterDatumEnde;
    report.dictionary.variables.getByName('filterDatumEnde').valueObject = filterDatumEnde;
    report.dictionary.variables.getByName('showZeit').valueObject = zeitAuswahl;
    viewer.report = report;


    // Rendering the viewer to selected element
    viewer.renderHtml('viewer');
  }

  /* Suche nach Datum und Name. Einzeln oder Zusammen */




}
